import { Theme } from '../../../themes';
import { ButtonProps, ButtonColorLiterals, ButtonSizeLiterals } from './Button.types';

interface GetAccessibleButtonColorsResult {
  rest: string;
  hover: string;
  active: string;
}

export const getAccessibleButtonColors = (
  color: ButtonProps['color'],
  theme: Theme,
): GetAccessibleButtonColorsResult => {
  const accessibleColorsMap: Record<ButtonColorLiterals, GetAccessibleButtonColorsResult> = {
    primary: {
      rest: theme.palette.text.secondary,
      hover: theme.palette.text.secondary,
      active: theme.palette.text.secondary,
    },
    secondary: {
      rest: theme.palette.text.primary,
      hover: theme.palette.text.primary,
      active: theme.palette.text.primary,
    },
    tertiary: {
      rest: theme.palette.text.secondary,
      hover: theme.palette.text.secondary,
      active: theme.palette.text.secondary,
    },
    error: {
      rest: theme.palette.text.secondary,
      hover: theme.palette.text.secondary,
      active: theme.palette.text.secondary,
    },
    warning: {
      rest: theme.palette.text.primary,
      hover: theme.palette.text.primary,
      active: theme.palette.text.primary,
    },
    info: {
      rest: theme.palette.text.secondary,
      hover: theme.palette.text.secondary,
      active: theme.palette.text.secondary,
    },
    success: {
      rest: theme.palette.text.secondary,
      hover: theme.palette.text.primary,
      active: theme.palette.text.secondary,
    },
  };

  return accessibleColorsMap[color!] ?? { rest: color, hover: color, active: color };
};

export const getButtonSize = (size: ButtonSizeLiterals, theme: Theme) => {
  const buttonSizeMap: Record<
    ButtonSizeLiterals,
    { width: string; height: string; padding: string; borderRadius: string }
  > = {
    lg: { width: '8rem', height: '2.2rem', padding: '1rem', borderRadius: theme.borderRadius.sm },
    md: { width: '5rem', height: '1.5rem', padding: '1rem', borderRadius: theme.borderRadius.sm },
    sm: { width: '5rem', height: '1.5rem', padding: '0.5rem', borderRadius: theme.borderRadius.sm },
  };

  return buttonSizeMap[size!];
};
